import React from 'react';

import { StandardButton, StandardButtonProps } from '@/components/shared/components/StandardButton';

export interface AiButtonProps extends StandardButtonProps {}

export const AiButton = React.forwardRef<HTMLButtonElement, AiButtonProps>((props, ref) => {
  const { style, ...buttonProps } = props;

  const aiStyle: React.CSSProperties = {
    ...style,
    // minWidth: '120px',
    justifyContent: 'flex-start',
    backgroundImage: 'linear-gradient(130deg, #ff9a9e 0%, #fad0c4 30%, #fbc2eb 70%, #a18cd1 100%)',
    color: '#2f0d7b',
    border: 'none !important',
    boxShadow: 'none !important',
  };

  return <StandardButton ref={ref} main style={aiStyle} {...buttonProps} />;
});
